var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"well-display",staticStyle:{"height":"130em"}},[_c('vue-editor',{staticStyle:{"height":"120em"},attrs:{"disabled":true,"editorToolbar":_vm.customToolbar},model:{value:(_vm.contrat.contenu),callback:function ($$v) {_vm.$set(_vm.contrat, "contenu", $$v)},expression:"contrat.contenu"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }